<template >
    <div id="t5">
        <div class="juzhon">
            <div class="boxtitle">
                <span class="tit_left"><img src="../assets/hsfz.png" ></span>
                <div class="nav">
                    <a  @click="ZMchagne('A')" :class="[ZM=='A'?'navactive':'']">{{ Masterlist.lists_A.title }}</a>
                    <a  @click="ZMchagne('B')" :class="[ZM=='B'?'navactive':'']">{{ Masterlist.lists_B.title }}</a>
                </div>
                <span class="tit_right"><a :href="curl+Masterlist['lists_'+ZM].id" target="_blank"> 更多资讯>></a></span>
            </div>

            <div class="Vidcontext">
                <div class="video_img">
                    <div class="spimg" v-if="status===false">
                        <img  id="playimg" @click="videopaly()" :src="lists[Sel].pic1" alt="">
                        <span><img src="../assets/paly1.png" alt=""> <div class="textdiv"><a :href="aurl+lists[Sel].fileID" target="_blank">{{ lists[Sel].title }}</a></div></span>
                    </div>
                    <div v-else class="video">
                        <div class="media_close" @click="videoclose()"></div>
                        <video  controls="controls" :src="lists[Sel].videoUrl" :poster="lists[Sel].pic1" autoplay ></video>
                    </div>
                </div>
                <ul>
                    <li v-for="(item,i) in lists" :key="i" :class="[Sel==i?'itemactive':'']" @click="Sel=i;videoclose()">
                        <a class="img_box" ><img :src="item.pic1" alt="">
                            <h3><a  >{{ item.title }}</a></h3>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import {inject,ref,onMounted} from 'vue'
export default {
    name:'T5',
    setup(){
        let ztreq=inject('ztreq')
        let aurl=ztreq.data.aurl
        let curl=ztreq.data.curl
        let Masterlist=ref({
            lists_A:{title:'赣东巨变',id:'2748',lists:[{videoUrl:"",pic1:"",title:''}]},
            lists_B:{title:'足迹·抚州荣光',id:'2749',lists:[{videoUrl:"",pic1:"",title:''}]},
        })
        let ZM=ref('A')
        let Sel=ref(0)
        let status=ref(false)
        let lists=ref([{videoUrl:"",pic1:"",title:'',fileID:''}])
        onMounted(()=>{
                axios.get(ztreq.data.geturl+'2748&pageSize=4&articleType=2').then((res)=>{
                Masterlist.value['lists_'+ZM.value].lists=res.data.list
                lists.value = Masterlist.value['lists_'+ZM.value].lists
            });
        });
        function getData(ID){
            axios.get(ztreq.data.geturl+ID+'&pageSize=4&articleType=2').then((res)=>{
                Masterlist.value['lists_'+ZM.value].lists=res.data.list
                lists.value = Masterlist.value['lists_'+ZM.value].lists
            });
        }
        //切换当前显示内容
        function ZMchagne(i){
            videoclose()
            ZM.value=i
            if(Masterlist.value['lists_'+ZM.value].lists[0].videoUrl==''){
                let ID = Masterlist.value['lists_'+ZM.value].id
                getData(ID)
            }else{
                lists.value =Masterlist.value['lists_'+ZM.value].lists
            }
        }
        //关闭视频
        function videoclose(){
            status.value=false
        }
        function videopaly(){
            status.value=true
        }
        return{
            aurl,lists,curl,Masterlist,ZM,ZMchagne,Sel,status,videoclose,videopaly
        }
    }  

}
</script>

<style scoped>
#t5{
    min-width: 1200px;
    width:100%;
    height: 700px;   
    background-color: #fff;
    padding-top: 40px;
}
.boxtitle{
    width: 1200px;
    height: 48px;
    overflow: hidden;
    border-bottom: 4px solid #fc0000;
    margin-bottom: 20px;
}
.boxtitle img{
    width: 157px;
}
.tit_left{
    float: left;
}
.tit_right{
    float: right;
    font-size: 18px;
    color: #333;
    margin-top: 18px;
}
.tit_right a{
    font-size: 18px;
    color: #333;
}
.tit_right a:hover{
    color: #fc0000;
    text-decoration: underline;
}
.nav{
    width: 800px;
    display: inline-block;
    padding-left: 20px;
}
.nav a{
    display: inline-block;
    margin-right: 15px;
    height: 30px;
    padding: 0 20px;
    line-height: 30px;
    color: #000;
    background: #eee;
    margin-top: 9px;
    border-radius: 15px;
}
.nav a:hover{
    color: white;
    background: #fc0000;
    cursor: pointer;
}
.nav .navactive{
    color: white;
    background: #fc0000;
}



.Vidcontext ul{
    clear: both;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column;
    width: 255px;
}
.Vidcontext ul li{
    width: 230px;
    float: left;
    margin: 8px 10px;
    height: 130px;
    border: 2px solid #b7b6b661;
    overflow: hidden;
    border-radius: 6px;
    cursor: pointer;
}
.Vidcontext img{
    width: 100%;
    height: 130px;
}
.img_box{
    display: block;
    height: 130px;
    width: 230px;
    overflow: hidden;
}

.Vidcontext h3{
    margin-bottom: 5px;
    margin-top: -32px;
    text-align: center;
    line-height: 28px;
    max-height: 48px;
    font-size: 14px;
    font-weight: normal;
    display: block;
    padding: 0px 10px 0px 10px;
    background: rgba(0, 0, 0, 0.6);
    position: relative;
    z-index: 9;
}
.Vidcontext h3 a{
    color: #fff;
}
.video_img{
    margin-right: 20px;
    width: 900px;
    height: 600px;
    overflow: hidden;
}
.Vidcontext .video_img img{
    width: 900px;
    height: 600px;
    border-radius: 6px;
}
.Vidcontext{
    display: flex;
    flex-direction: row;
    justify-content: center;
    border-radius: 6px;
}
.Vidcontext ul .itemactive{
    border: 2px solid #fc0000;
}
.Vidcontext .video_img span img{
    width: 36px;
    height: 36px;
    padding-top: 10px;
    display: inline-block;
}
.Vidcontext .video_img span{
    display: block;
    background: rgba(0, 0, 0, 0.6);
    position: relative;
    z-index: 2;
    margin-top: -60px;
    text-align: left;
    line-height: 40px;
    height: 60px;
    font-size: 24px;
    font-weight: normal;
    padding: 0px 10px 0px 10px;
}
.Vidcontext .video_img span a{
    color: #fff;
    cursor: pointer;
}
.textdiv{
    position: absolute;
    left: 60px;
    bottom: 2px;
    z-index: 5;
    color: #fff;
    padding: 10px;
    font-size: 26px;
}
.Vidcontext .video_img span a:hover{
    text-decoration: underline;
}
#playimg{
    /* object-fit: cover; */
    cursor: pointer;
}
.video{
    width: 900px;
    height: 600px;
    border-radius: 6px;
    background-color: #000000;
    position: relative;
}
video{
    width: 900px;
    height: 560px;
}
.media_close{
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;
    width: 40px;
    height: 40px;
    background: url(../assets/close.png);
    -webkit-background-size: 100% 100%;
    -moz-background-size: 100%;
    background-size: 100%;
    cursor: pointer;
}
</style>